import { CATALOG_RESERVED_ROUTE_SEGMENTS } from '@features/product-catalog/utils/catalog-public-routes';
import { readLastPublicStoreSlug } from '@features/product-catalog/utils/catalog-last-store-slug.storage';

const RESERVED = new Set<string>(CATALOG_RESERVED_ROUTE_SEGMENTS);

/**
 * Destino del CTA "Volver" en 404 pública.
 * Nunca apunta a `/authentication` (backoffice de dueños).
 *
 * Prioridad: `?from=` con slug de tienda → último slug en session → `/website`.
 */
export function resolvePublicNotFoundHomeCommands(
  fromPath: string | null | undefined,
  rememberedSlug: string | null | undefined = readLastPublicStoreSlug(),
): string[] {
  const fromCommands = commandsFromPublicStorePath(fromPath);
  if (fromCommands) {
    return fromCommands;
  }

  const remembered = (rememberedSlug ?? '').trim().toLowerCase();
  if (remembered && !RESERVED.has(remembered)) {
    return ['/', remembered, 'tienda'];
  }

  return ['/website'];
}

function commandsFromPublicStorePath(fromPath: string | null | undefined): string[] | null {
  const path = (fromPath ?? '').trim();
  const segments = path.split('/').filter(Boolean);
  const first = segments[0]?.toLowerCase() ?? '';
  if (!first || RESERVED.has(first)) {
    return null;
  }
  if (segments.length > 1) {
    return ['/', first, 'tienda'];
  }
  return ['/', first];
}
